import React from 'react';
import { useFormContext } from "react-hook-form";
import { translate } from "../../Services/translation";

const PaymentMethods = ({ paymentMethods }) => {
    const { register, getValues, handleSubmit, formState } = useFormContext();

    return (
        <div>
            <p className="checkout__section-title">{translate('checkout.form.paymentmethods')}</p>
            <div className="card">
                <div className="card__body card__body--large">
                    <div className="checkout__radio-container">
                        {
                            paymentMethods.options.map(x => (
                                <div>
                                    <input
                                        className="checkout__radio-button"
                                        id={"payment-method-" + x.key}
                                        type="radio"
                                        value={x.key}
                                        {...register('paymentMethod')}
                                        defaultChecked={x.checked}
                                    />
                                    <label htmlFor={"payment-method-" + x.key}
                                           className="checkout__radio-label">{translate(x.text)}</label>

                                    {x.message && <p className="checkout__text"><br/>{x.message}</p>}
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentMethods;
